import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const { VITE_BASE_URL } = import.meta.env;
// Define your Report API slice
export const createReportApi = createApi({
  reducerPath: "createReportApi",
  baseQuery: fetchBaseQuery({ baseUrl: VITE_BASE_URL }),
  endpoints: (builder) => ({
    createReport: builder.mutation({
      query: (data) => ({
        url: VITE_BASE_URL + "/api/v1/page/report-page",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useCreateReportMutation } = createReportApi;
